import React, { useState } from 'react';
import { Box, Button, Chip, Stack, Typography } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { useSelector } from '../../../redux/store';
import Image from '../../../components/Image';
import RestoreIcon from '../../../assets/deposit/restore.png';
import BalanceRestoreIcon from '../../../assets/balance/restore.png';
import CustomModal from '../../../components/CustomModal';
import Iconify from '../../../components/Iconify';
import { fNumberCommaSeparated } from '../../../utils/formatNumber';
import useResponsive from '../../../hooks/useResponsive';
import Restore from '../../../assets/withdraw/restore.png';
import Details from './withdraw/Details';
import useLocales from '../../../hooks/useLocales';

// TODO: Check Responsiveness

const MemberBalanceSection = ({ handleRestore }) => {
  const { translate } = useLocales();
  const isDesktop = useResponsive('up', 'lg');
  const [openDetails, setOpenDetails] = useState();
  const [openOthers, setOpenOthers] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const { memberInfo } = useSelector((x) => ({
    ...x.lookup,
  }));
  const currency = memberInfo?.currency || '';
  const walletBalance = memberInfo?.walletBalance || 0;

  // const handleRestore = () => {
  //   // TODO: Call "Restore" API here

  //   // Dummy api call
  //   setIsLoading(true);
  //   setTimeout(() => setIsLoading(false), 1000);
  // };

  return (
    <>
      {isDesktop ? (
        <Stack
          sx={{ backgroundColor: '#fff', p: 2, borderRadius: 1, mb: 2 }}
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <Typography variant="h5">
            {translate('wallet_balance')}: {memberInfo?.currency || ''}{' '}
            {fNumberCommaSeparated(memberInfo?.walletBalance || 0)}
          </Typography>

          <Box sx={{ display: 'flex', gap: 1 }}>
            {/* <LoadingButton
              onClick={handleRestore}
              sx={{ backgroundColor: '#F6F7F9', color: 'black', px: 3 }}
              endIcon={<Image src={RestoreIcon} alt="restore" width={8} height={8} />}
              loading={isLoading}
              disabled={isLoading}
            >
              {translate('restore')}
            </LoadingButton> */}
            <Button onClick={() => setOpenDetails(true)} sx={{ backgroundColor: '#F6F7F9', color: 'black', px: 3 }}>
              {translate('details')}
            </Button>
          </Box>
        </Stack>
      ) : (
        <>
          <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
            <Typography variant="h5"> {translate('wallet_balance')}</Typography>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <Typography color={'#8991A7'} onClick={() => setOpenDetails(true)}>
                {translate('details')}
              </Typography>
              <Iconify icon="mdi:chevron-right" />
            </Box>
          </Box>
          {/* <Box sx={{ display: 'flex', justifyContent: 'space-between', gap: '28px' }}>
            <Box
              sx={{
                backgroundColor: '#fff',
                flex: 1,
                display: 'flex',
                alignItems: 'center',
                borderRadius: 99,
                paddingX: '12px',
                justifyContent: 'space-between',
              }}
            >
              <Box sx={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                <Typography sx={{ fontSize: '14px', fontWeight: 600 }}>{memberInfo?.currency}</Typography>
                <Typography sx={{ fontSize: '17px', fontWeight: 600 }}>{memberInfo?.walletBalance}</Typography>
              </Box>
              <Image onClick={handleRestore} src={RestoreIcon} alt="restore" width={8} height={8} />
            </Box>
            <Box onClick={handleRestore} sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <Image src={Restore} alt="restore" sx={{ width: '30px', height: '30px' }} />
              <Typography sx={{ fontSize: '10px', fontWeight: 500, color: '#333' }}> {translate('restore')}</Typography>
            </Box>
          </Box> */}
        </>
      )}
      <Details
        open={openDetails}
        onClose={() => setOpenDetails(false)}
        data={{
          currency,
          walletBalance,
          // gameProvider, // TODO Extract the game provider from the API
        }}
      />
    </>
  );
};

export default MemberBalanceSection;
